import script from "./HighLights.vue?vue&type=script&setup=true&lang=js"
export * from "./HighLights.vue?vue&type=script&setup=true&lang=js"

import "./HighLights.vue?vue&type=style&index=0&id=c6836e2a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6836e2a"]])

export default __exports__